import React from "react";
import { FourTagEntity } from '../../prometeTags'
import './style.less'

interface CycleTagProps {
  onClick?: (...args: any) => void;
  backgroundColor: string;
  items: FourTagEntity;
  style?: React.CSSProperties;
}

const clsPrefix = 'cycle-tag'

const CycleTag: React.FC<CycleTagProps> = ({
  onClick = () => null,
  items,
  backgroundColor = '',
  style = {}
}) => {
  return (
    <div style={{ backgroundColor, ...style }} className={`${clsPrefix}`} onClick={onClick}>
      {[0, 1, 2, 3].map((_, index) => (
        <div
          className={`${clsPrefix}__item`}
          // @ts-ignore
          style={{ fontSize: `${items[index].size}px`, color: items[index].color, backgroundColor: items[index].backgroundColor || backgroundColor}}
          // @ts-ignore
        >{items[index].text}</div>
      ))}
    </div>
  )
}

export default CycleTag